import { create } from "zustand";

interface IProfileModal {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const useProfileModal = create<IProfileModal>()((set) => ({
  isOpen: false,
  onOpen: () => {
    set(() => ({ isOpen: true }));
  },
  onClose: () => {
    set(() => ({ isOpen: false }));
  },
}));
